import { Box } from "@mui/material";
import { TitleSection } from "../components/TitleSection";

import { VerticalSlider } from "../components/sliderPage/verticalSlider";

export const SecAbout = () => {
  return (
    <>
      <VerticalSlider />
      <Box
        id={"about"}
        sx={{
          display: "flex",
          py: 1,
          mt: "50px",
          flexDirection: {
            xs: "column",
            md: "row",
          },
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            zIndex: 50,
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              zIndex: 50,
              height: {
                xs: "250px",
                sm: "300px",
                md: "350px",
              },
              width: {
                xs: "250px",
                sm: "300px",
                md: "350px",
              },
              borderRadius: "24px",
              backgroundColor: "var(--c-bg-content-color)",
              transition: "all 0.5s ease-in-out",
              border: "2px solid var(--c-bg-content-color)",
              boxShadow: "var(--c-box-shadow-btn)",
              overflow: "hidden",
              "&:hover": {
                backgroundColor: "var(--c-main-color-hover)",
                boxShadow: "var(--c-box-shadow-btn)",
              },
            }}
          >
            <Box
              component="img"
              sx={{
                zIndex: 50,
                height: "auto",
                width: "100%",
                borderRadius: "5%",
              }}
              alt="The house from the offer."
              src="/img/doHomeworc.webp"
            />
          </Box>
        </Box>

        <Box
          sx={{
            zIndex: 50,
            flex: 1,
            mt: {
              xs: 2,
              md: 0,
            },
            display: "flex",
            justifyContent: "center",
            alignItems: {
              xs: "center",
              md: "start",
            },
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              zIndex: 50,
              paddingX: "64px",
              fontWeight: 500,
              fontSize: "2rem",
            }}
          >
            <TitleSection title={"About me"} />
          </Box>
          <Box
            sx={{
              zIndex: 50,
              paddingX: {
                xs: 4,
                sm: 6,
                md: 8,
              },
              fontSize: {
                xs: "0.8rem",
                sm: "0.9rem",
                md: "1rem",
              },
              fontWeight: 300,
              color: "var(--c-text-color)",
            }}
            component={"p"}
          >
            I am dedicated and hardworking, driven by self-education and a
            passion for IT. I am results-oriented and constantly seek new
            knowledge and opportunities for self-development. Enthusiastic about
            coding, I am eager to apply my skills in real-world projects.
          </Box>
        </Box>
      </Box>
    </>
  );
};
